import React, { useState, useEffect } from 'react';

import api from 'services/api';
import { useDebounce } from 'hooks/useDebounce';

import Icon from 'components/Icon';
import Spinner from 'components/Spinner';
import GridFlex from 'components/GridFlex';
import Button from 'components/Button';
import Text from 'components/Text';
import { Input } from 'components/Fields';

import ModalCreateMaterial from 'components/ModalCreateMaterial';
import Header from '../Header';
import ModalDeleteOrIsActive, { Types } from '../ModalDeleteOrIsActive';

import { Container } from './styles';
import { List, Item, ContainerActions, SwitchTheme } from '../styles';

interface IList {
  id: number;
  name: string;
  type: string;
  isActive?: boolean;
}

const endpoint = '/materials';

const Material: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [list, setList] = useState<IList[]>([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState<Types | boolean>(false);
  const [materialSelected, setMaterialSelected] = useState<any>(false);

  const getMaterials = async () => {
    setLoading(true);

    const newList: IList[] = await api.get(`${endpoint}?name=${search}`);

    setList(newList);

    setLoading(false);
  };

  const autoSave = useDebounce(search);

  const saveChange = async () => {
    getMaterials();
  };

  useEffect(() => {
    saveChange();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSave]);

  return (
    <Container>
      <ModalCreateMaterial
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onSaved={() => getMaterials()}
      />

      <Header
        onCreate={() => setModalOpen(true)}
        title="Material management"
        titleCreate="Create new material"
      />

      {!!openModal && (
        <ModalDeleteOrIsActive
          type={openModal as Types}
          endpoint={endpoint}
          itemName={materialSelected.name}
          id={materialSelected.id}
          isActive={materialSelected.isActive}
          onClose={() => setOpenModal(false)}
          onCreated={() => {
            if (openModal === Types.DELETE) {
              setList(list.filter(i => i.id !== materialSelected.id));
            }

            if (openModal === Types.ISACTIVE) {
              const newList = list;

              newList[materialSelected.index] = {
                ...newList[materialSelected.index],
                isActive: !materialSelected.isActive,
              };

              setList(newList);
            }
            setOpenModal(false);
          }}
        />
      )}

      <Input
        name="search"
        onChange={e => setSearch(e.target.value)}
        value={search}
        placeholder="Search material"
        width="100%"
        dataTest="search"
        leftContent={
          <Icon
            icon="search"
            color="grayLightText"
            width="18px"
            height="18px"
          />
        }
      />
      <List>
        {loading ? (
          <GridFlex justifyContent="center" alignItems="center">
            <Spinner />
          </GridFlex>
        ) : (
          <>
            {list.map(({ name, id, isActive }, index) => (
              <Item key={id}>
                <Text fontSize={14} fontWeight="normal" color="black">
                  {name}
                </Text>
                <ContainerActions>
                  <SwitchTheme
                    checked={!isActive}
                    data-testid={`button-row-isActive-${id}`}
                    onClick={() => {
                      setOpenModal(Types.ISACTIVE);
                      setMaterialSelected({ name, id, isActive, index });
                    }}
                  />
                  <Button
                    width="95px"
                    padding="6px 30px"
                    data-testid={`button-row-delete-${id}`}
                    onClick={() => {
                      setOpenModal(Types.DELETE);
                      setMaterialSelected({ name, id, isActive, index });
                    }}
                  >
                    Delete
                  </Button>
                </ContainerActions>
              </Item>
            ))}
          </>
        )}
      </List>
    </Container>
  );
};

export default Material;
